var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useCallback } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import { useHistory, useLocation } from "react-router-dom";
import { useApiAction } from "../utils/useApiAction";
import { openPublisherPrefixRange, closePublisherPrefixRange, deletePublisherPrefixRange, } from "../api/publisherPrefixRange";
import { getErrorCode } from "../utils/getErrorCode";
import { PublisherPrefixErrorTypes } from "../routes/publisher-prefix-range/PublisherPrefixErrorTypes";
export var usePublisherPrefixRangeActions = function () {
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var history = useHistory();
    var location = useLocation();
    var performAction = useApiAction().performAction;
    var _a = useState(null), selectedPublisherPrefix = _a[0], setSelectedPublisherPrefix = _a[1];
    var _b = useState(false), showConfirmModal = _b[0], setShowConfirmModal = _b[1];
    var _c = useState(null), confirmAction = _c[0], setConfirmAction = _c[1];
    var _d = useState(""), modalMessage = _d[0], setModalMessage = _d[1];
    var _e = useState(null), confirmMessage = _e[0], setConfirmMessage = _e[1];
    var _f = useState(false), errorOpen = _f[0], setErrorOpen = _f[1];
    var _g = useState(""), errorMessage = _g[0], setErrorMessage = _g[1];
    var openConfirmModal = useCallback(function (action, message) {
        setConfirmAction(function () { return action; });
        setModalMessage(message);
        setConfirmMessage(null);
        setShowConfirmModal(true);
    }, []);
    var handleOpenPrefix = useCallback(function (prefixId) {
        return performAction({
            apiCall: function () { return openPublisherPrefixRange(ky, prefixId); },
            queryKey: "publisher-prefix-ranges",
            errorMsg: formatMessage({
                id: "ui-br-agency.publisher-prefix-range.error.open",
            }),
        });
    }, [ky, performAction, formatMessage]);
    var handleClosePrefix = useCallback(function (prefixId) {
        return performAction({
            apiCall: function () { return closePublisherPrefixRange(ky, prefixId); },
            queryKey: "publisher-prefix-ranges",
            errorMsg: formatMessage({
                id: "ui-br-agency.publisher-prefix-range.error.close",
            }),
        });
    }, [ky, performAction, formatMessage]);
    var handleDeletePrefix = useCallback(function (prefixId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1, code;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 1, , 3]);
                    performAction({
                        apiCall: function () { return deletePublisherPrefixRange(ky, prefixId); },
                        queryKey: "publisher-prefix-ranges",
                        errorMsg: formatMessage({
                            id: "ui-br-agency.publisher-prefix-range.error.delete",
                        }),
                    });
                    return [3 /*break*/, 3];
                case 1:
                    error_1 = _a.sent();
                    return [4 /*yield*/, getErrorCode(error_1)];
                case 2:
                    code = _a.sent();
                    if (code === PublisherPrefixErrorTypes.CHILDREN) {
                        setErrorMessage(formatMessage({
                            id: "ui-br-agency.publisher-prefix-range.delete.children",
                        }));
                        setErrorOpen(true);
                        return [2 /*return*/];
                    }
                    setErrorMessage(formatMessage({ id: "ui-br-agency.agency-prefix.submit" }));
                    setErrorOpen(true);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [ky, performAction, formatMessage]);
    var openConfirmModalDelete = useCallback(function (prefix) {
        openConfirmModal(function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, handleDeletePrefix(prefix.id)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, formatMessage({
            id: "ui-br-agency.publisher-prefix-range.delete.confirm",
        }));
    }, [openConfirmModal, handleDeletePrefix, formatMessage]);
    var openConfirmModalToggle = useCallback(function (prefix) {
        var isActive = prefix.status === "ACTIVE";
        var actionText = isActive
            ? formatMessage({ id: "ui-br-agency.button.close" })
            : formatMessage({ id: "ui-br-agency.button.open" });
        openConfirmModal(function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isActive) return [3 /*break*/, 2];
                        return [4 /*yield*/, handleClosePrefix(prefix.id)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, handleOpenPrefix(prefix.id)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); }, formatMessage({ id: "ui-br-agency.international-prefix.action.confirm" }, { actionText: actionText }));
    }, [openConfirmModal, handleClosePrefix, handleOpenPrefix, formatMessage]);
    var handleRowClick = useCallback(function (item) {
        var _a;
        var currentParams = new URLSearchParams(location.search);
        currentParams.delete("detail");
        currentParams.set("detail", (_a = item.id) !== null && _a !== void 0 ? _a : "");
        history.push({ search: currentParams.toString() });
        setSelectedPublisherPrefix(item);
    }, [location.search, history]);
    var handleCloseDetail = useCallback(function () {
        setSelectedPublisherPrefix(null);
        var queryParams = new URLSearchParams(location.search);
        queryParams.delete("detail");
        history.replace({ search: queryParams.toString() });
    }, [location.search, history]);
    var handleConfirm = useCallback(function (refetch) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirmAction) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, confirmAction()];
                case 2:
                    _a.sent();
                    setConfirmMessage(formatMessage({ id: "ui-br-agency.action.success" }));
                    refetch();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.error("Error performing action:", error_2);
                    setConfirmMessage(formatMessage({ id: "ui-br-agency.action.failure" }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [confirmAction, formatMessage]);
    var closeConfirmModal = useCallback(function () {
        setShowConfirmModal(false);
    }, []);
    var closeErrorModal = useCallback(function () {
        setErrorOpen(false);
    }, []);
    return {
        selectedPublisherPrefix: selectedPublisherPrefix,
        handleRowClick: handleRowClick,
        handleCloseDetail: handleCloseDetail,
        openConfirmModalDelete: openConfirmModalDelete,
        openConfirmModalToggle: openConfirmModalToggle,
        // Modal states
        showConfirmModal: showConfirmModal,
        confirmMessage: confirmMessage,
        modalMessage: modalMessage,
        handleConfirm: handleConfirm,
        closeConfirmModal: closeConfirmModal,
        // Error states
        errorOpen: errorOpen,
        errorMessage: errorMessage,
        closeErrorModal: closeErrorModal,
    };
};
